import { BASE_URL } from "@/constants/config";
import { request } from "@/utils/request";

export const MEMBER_MAPPINGS_ENDPOINTS = {
  base: `${BASE_URL}api/category_mapping/`,
};

class CategoryMappings {
  async getAllMemberMappings() {
    const {data} = await request({
      url: MEMBER_MAPPINGS_ENDPOINTS.base,
    });
    return data
  }

  async updateBatchMemberMappings(batch_member_mappings) {
    const { data } = await request({
      url: MEMBER_MAPPINGS_ENDPOINTS.base,
      method: "PUT",
      body: batch_member_mappings
    });
    return data;
  }
}

export const CategoryMappingsServices = new CategoryMappings();
